export const ONBOARDING_AGENT_NEGATIVE_FEEDBACK_MODAL_CUSTOM_STYLES = {
    content: { width: "550px", maxHeight: "90vh" },
};
